var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmallLogoPresentation = function SvgSmallLogoPresentation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3865 11.9458C30.5297 18.3387 25.1149 23.2811 18.579 23.2811C12.043 23.2811 6.6283 18.3387 5.77149 11.9458H0C0.885472 21.5528 8.88019 29.0957 18.579 29.0957C28.2778 29.0957 36.2693 21.5528 37.158 11.9458H31.3865V11.9458Z",
    fill: "#BABABF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5789 17.0433C23.2195 17.0433 26.9814 13.228 26.9814 8.52165C26.9814 3.81527 23.2195 0 18.5789 0C13.9384 0 10.1765 3.81527 10.1765 8.52165C10.1765 13.228 13.9384 17.0433 18.5789 17.0433Z",
    fill: "#FF8778"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmallLogoPresentation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/small-logo-presentation.a42cdd34d5e858e693d94ae2288be17f.svg";